import React from "react";
import "./Services.css";
import { FaCartFlatbedSuitcase } from "react-icons/fa6";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { RiShieldCheckLine } from "react-icons/ri";
import { motion } from "framer-motion";

const Services = () => {
  const services = [
    {
      icon: <FaCartFlatbedSuitcase className="service-icon" />,
      title: "Fast And Free Delivery",
      description: "Free delivery for all orders over ₹1000",
      color: "#39B54A"
    },
    {
      icon: <TfiHeadphoneAlt className="service-icon" />,
      title: "24/7 Customer Support",
      description: "Friendly round-the-clock customer support",
      color: "#800080"
    },
    {
      icon: <RiShieldCheckLine className="service-icon" />,
      title: "Coin Redeem Guarantee",
      description: "Points redeemed within 24 hours",
      color: "#6a006a"
    }    
  ];

  return (
    <section className="services-section">
      <div className="services-container">
        {services.map((service, index) => (
          <motion.div 
            key={index}
            className="service-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ y: -10 }}
          >
            <div 
              className="icon-container"
              style={{ backgroundColor: `${service.color}20` }}
            >
              {service.icon}
            </div>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
            <div 
              className="service-underline" 
              style={{ backgroundColor: service.color }}
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Services;